import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import { AjouterCommentaire, LikeCommentaire, DislikeCommentaire, SupprimerCommentaire } from "./slice";
import { updateClimatisseur } from "./action";
import { ThumbsUp, ThumbsDown, Trash2, Star, MessageSquare, ArrowLeft } from "lucide-react";
import "../styles/ajouterCommantaire.css";

export function AjouterCommantaire() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [Name, setName] = useState("");
    const [Commantaire, setCommantaire] = useState("");
    const [Avis, setAvis] = useState("");

    const listC = useSelector(s => s.listC);
    const Climatisseur = listC.find(a => a.id == id);

    useEffect(() => {
        const loggedUser = localStorage.getItem('user');
        if (loggedUser) {
            const parsedUser = JSON.parse(loggedUser);
            setUser(parsedUser);
            setName(parsedUser.name || parsedUser.email.split('@')[0]);
        }
    }, [navigate]);

    if (!Climatisseur) return null;

    if (!user) {
        return (
            <div className="add-comment-page">
                <div className="comment-page-content" style={{ justifyContent: 'center' }}>
                    <div className="premium-card glass-card" style={{ textAlign: 'center', maxWidth: '500px' }}>
                        <h2><span>Accès Restreint</span>Oops !</h2>
                        <p style={{ marginBottom: '30px', color: '#666' }}>Vous devez être connecté pour partager votre avis.</p>
                        <button className="submit-btn-animated" onClick={() => navigate("/login")}>Se connecter</button>
                        <Link to="/" className="back-link">Retour à l'accueil</Link>
                    </div>
                </div>
            </div>
        );
    }

    const handleLike = (commentaireId) => {
        const userEmail = user.email;
        dispatch(LikeCommentaire({ climatiseurId: id, commentaireId, userEmail }));
        
        // Prepare persistent object immediately
        const currentClimatisseur = { ...Climatisseur };
        const updatedComments = currentClimatisseur.commantaires.map(com => {
            if (com.id === commentaireId) {
                const likedBy = com.likedBy ? [...com.likedBy] : [];
                const dislikedBy = com.dislikedBy ? [...com.dislikedBy] : [];
                let like = com.like || 0;
                let dislike = com.dislike || 0;

                if (likedBy.includes(userEmail)) {
                    likedBy.splice(likedBy.indexOf(userEmail), 1);
                    like = Math.max(0, like - 1);
                } else {
                    likedBy.push(userEmail);
                    like += 1;
                    if (dislikedBy.includes(userEmail)) {
                        dislikedBy.splice(dislikedBy.indexOf(userEmail), 1);
                        dislike = Math.max(0, dislike - 1);
                    }
                }
                return { ...com, likedBy, dislikedBy, like, dislike };
            }
            return com;
        });
        
        dispatch(updateClimatisseur({ ...currentClimatisseur, commantaires: updatedComments }));
    };

    const handleDislike = (commentaireId) => {
        const userEmail = user.email;
        dispatch(DislikeCommentaire({ climatiseurId: id, commentaireId, userEmail }));

        // Prepare persistent object immediately
        const currentClimatisseur = { ...Climatisseur };
        const updatedComments = currentClimatisseur.commantaires.map(com => {
            if (com.id === commentaireId) {
                const likedBy = com.likedBy ? [...com.likedBy] : [];
                const dislikedBy = com.dislikedBy ? [...com.dislikedBy] : [];
                let like = com.like || 0;
                let dislike = com.dislike || 0;

                if (dislikedBy.includes(userEmail)) {
                    dislikedBy.splice(dislikedBy.indexOf(userEmail), 1);
                    dislike = Math.max(0, dislike - 1);
                } else {
                    dislikedBy.push(userEmail);
                    dislike += 1;
                    if (likedBy.includes(userEmail)) {
                        likedBy.splice(likedBy.indexOf(userEmail), 1);
                        like = Math.max(0, like - 1);
                    }
                }
                return { ...com, likedBy, dislikedBy, like, dislike };
            }
            return com;
        });
        
        dispatch(updateClimatisseur({ ...currentClimatisseur, commantaires: updatedComments }));
    };

    const handleDelete = (commentaireId) => {
        if (window.confirm("Voulez-vous supprimer ce commentaire ?")) {
            dispatch(SupprimerCommentaire({ climatiseurId: id, commentaireId }));
            
            // Persist
            const updatedComments = Climatisseur.commantaires.filter(com => com.id != commentaireId);
            dispatch(updateClimatisseur({ ...Climatisseur, commantaires: updatedComments }));
        }
    };

    function Ajouter(e) {
        e.preventDefault();
        if (!Commantaire || !Avis) {
            alert("Veuillez remplir tous les champs !");
            return;
        }

        const allComments = listC.flatMap(c => c.commantaires || []);
        const newCommentId = allComments.length > 0 
            ? Math.max(...allComments.map(c => c.id)) + 1 
            : 1;

        const newComment = {
            id: newCommentId,
            username: Name,
            commantaire: Commantaire,
            avis: Avis,
            like: 0,
            dislike: 0,
            likedBy: [],
            dislikedBy: [],
            status: 'en attente'
        };

        dispatch(AjouterCommentaire({
            climatiseurId: parseInt(id),
            commentaire: newComment
        }));

        // Persist
        const updatedComments = [...(Climatisseur.commantaires || []), newComment];
        dispatch(updateClimatisseur({ ...Climatisseur, commantaires: updatedComments }));

        setCommantaire("");
        setAvis("");
    }

    const renderStars = (avis) => {
        const count = parseInt(avis.split(' ')[0]) || 0;
        return (
            <div className="mini-rating">
                {[...Array(5)].map((_, i) => (
                    <Star 
                        key={i} 
                        size={14} 
                        className={i < count ? "mini-star active" : "mini-star"} 
                        fill={i < count ? "#ffc107" : "none"}
                        color={i < count ? "#ffc107" : "#ccc"}
                    />
                ))}
            </div>
        );
    };

    const ratingOptions = [5, 4, 3, 2, 1];

    return (
        <div className="add-comment-page">
            
            <div className="comment-page-content">
                <div className="dual-pane-card">
                    {/* Left Pane: Form (Sticky) */}
                    <div className="pane-left sticky-pane">
                        <div className="form-header">
                            <span>Partagez votre avis</span>
                            <h2>Donnez votre avis</h2>
                        </div>
                        
                        <form onSubmit={Ajouter} className="form-container-animated">
                            <div className="premium-form-group">
                                <label>Utilisateur</label>
                                <input
                                    type="text"
                                    className="premium-input readonly"
                                    value={Name}
                                    readOnly
                                />
                            </div>

                            <div className="premium-form-group">
                                <label>Votre commentaire</label>
                                <textarea
                                    className="premium-input"
                                    placeholder="Dites-nous ce que vous avez pensé..."
                                    value={Commantaire}
                                    onChange={(e) => setCommantaire(e.target.value)}
                                    required
                                ></textarea>
                            </div>

                            <div className="premium-form-group">
                                <label>Votre note</label>
                                <div className="star-rating">
                                    {ratingOptions.map((val) => (
                                        <React.Fragment key={val}>
                                            <input
                                                type="radio"
                                                id={`star${val}`}
                                                name="avis"
                                                value={`${val} ${val === 1 ? 'étoile' : 'étoiles'}`}
                                                className="star-input"
                                                checked={Avis === `${val} ${val === 1 ? 'étoile' : 'étoiles'}`}
                                                onChange={(e) => setAvis(e.target.value)}
                                                required
                                            />
                                                <label htmlFor={`star${val}`} className="star-label">
                                                    <Star 
                                                        size={30} 
                                                        fill={parseInt(Avis) >= val ? "#ffc107" : "none"} 
                                                        color={parseInt(Avis) >= val ? "#ffc107" : "#ccc"} 
                                                    />
                                                </label>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>

                            <button type="submit" className="submit-btn-animated">
                                Envoyer mon avis
                            </button>
                        </form>

                        <button className="back-link" onClick={() => navigate(-1)} style={{background:'none', border:'none', cursor:'pointer', width:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:'8px', marginTop:'10px', marginBottom: '10px'}}>
                            <ArrowLeft size={18} /> Annuler et Retour
                        </button>
                    </div>

                    {/* Vertical Line */}
                    <div className="vertical-divider"></div>

                    {/* Right Pane: Comments List */}
                    <div className="pane-right">
                        {(() => {
                            const validatedComments = (Climatisseur.commantaires || []).filter(c => c.status === 'validé');
                            return (
                                <>
                                    <div className="list-header">
                                        <h3>
                                            Avis clients 
                                            <span className="count">{validatedComments.length}</span>
                                        </h3>
                                    </div>
                                    
                                    <div className="comments-scroll-area">
                                        {validatedComments.length === 0 ? (
                                            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                                                <p style={{ display: 'block', marginBottom: '10px' }}><MessageSquare size={50} color="#ccc" /></p>
                                                <p style={{ color: '#888', fontWeight: '600' }}>
                                                    Aucun avis pour le moment.
                                                </p>
                                                <p style={{ color: '#aaa', fontSize: '0.9rem' }}>
                                                    Soyez le premier à partager votre expérience !
                                                </p>
                                            </div>
                                        ) : (
                                            [...validatedComments].sort((a, b) => b.id - a.id).map(c => (
                                                <div key={c.id} className="comment-item">
                                                    <div className="item-top">
                                                        <div className="user-meta">
                                                            <h6>{c.username}</h6>
                                                            {renderStars(c.avis)}
                                                        </div>
                                                        {c.username === Name && (
                                                            <button className="mini-delete-btn" onClick={() => handleDelete(c.id)} title="Supprimer mon avis">
                                                                <Trash2 size={16} />
                                                            </button>
                                                        )}
                                                    </div>
                                                    <p className="item-text">{c.commantaire}</p>
                                                    <div className="item-actions">
                                                        <button 
                                                            className={`action-btn ${c.likedBy?.includes(user?.email) ? 'active-like' : ''}`} 
                                                            onClick={() => handleLike(c.id)}
                                                            style={{color: c.likedBy?.includes(user?.email) ? '#3b82f6' : '#666'}}
                                                        >
                                                            <ThumbsUp size={16} fill={c.likedBy?.includes(user?.email) ? '#3b82f6' : 'none'} /> <span>{c.like}</span>
                                                        </button>
                                                        <button 
                                                            className={`action-btn ${c.dislikedBy?.includes(user?.email) ? 'active-dislike' : ''}`} 
                                                            onClick={() => handleDislike(c.id)}
                                                            style={{color: c.dislikedBy?.includes(user?.email) ? '#ef4444' : '#666'}}
                                                        >
                                                            <ThumbsDown size={16} fill={c.dislikedBy?.includes(user?.email) ? '#ef4444' : 'none'} /> <span>{c.dislike}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </>
                            );
                        })()}
                    </div>
                </div>
            </div>
        </div>
    );
}